{
    "raporkarne": {
        "Baslik": "Performans Karnesi",
        "Tarih": "Rapor Tarihi",
        "Firma": "Ürün",
        "Aylar": "İncelenecek Aylar (Süre)",
        "Onayli": "Onaylı",
        "Ape": "APE",
        "Tutar": "Tutar",
        "Iptal": "İptal",
        "Cayma": "Cayma",
        "RandevuUygun": "Uygun Randevu",
        "RandevuHedef": "Hedef Randevu",
        "ReferansYapilan": "Yapılan Referans",
        "ReferansHedef": "Hedef Referans",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "TersLogik": "Ters Logik (Geriye Doğru)",
        "QuarterMod": "Quarter Modu (Çeyrekler)"
    }
}
